import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=aa42b146&scoped=true&"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=aa42b146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa42b146",
  null
  
)

export default component.exports